<div class="event-detail-dialog">
  <h2 mat-dialog-title>
    <mat-icon class="title-icon">
      {{ isReminder ? 'notifications' : 'event' }}
    </mat-icon>
    {{ event.title.length > 20 ? (event.title | slice:0:20) + '...' : event.title }}
  </h2>

  <div mat-dialog-content>
    <!-- Típus + Státusz -->
    <div class="detail-chips">
      <mat-chip-set>
        <mat-chip class="event-type-chip" [style.background]="event.color || '#1976D2'" style="color: white">
          {{ eventTypeLabel }}
        </mat-chip>
        @if (event.kum_status && !isReminder) {
          <app-call-center-chip [config]="createKumStatusChipConfig(event.kum_status)"></app-call-center-chip>
        }
        @if (event.status && event.status !== 'scheduled') {
          <mat-chip class="status-chip" [class.status-completed]="event.status === 'completed'">{{ statusLabel }}</mat-chip>
        }
      </mat-chip-set>
    </div>

    <!-- Időpont -->
    <div class="detail-row">
      <mat-icon>schedule</mat-icon>
      <div>
        <span>{{ formattedStart }}</span>
        @if (!isReminder && event.end) {
          <span> — {{ formattedEnd }}</span>
        }
        @if (event.allDay) {
          <span class="all-day-badge">Egész napos</span>
        }
      </div>
    </div>

    <!-- Helyszín -->
    @if (event.location) {
      <div class="detail-row">
        <mat-icon>location_on</mat-icon>
        <span>{{ event.location }}</span>
      </div>
    }

    <!-- Cég / Ügyfél -->
    @if (event.company_name) {
      <div class="detail-row">
        <mat-icon>business</mat-icon>
        <span>{{ event.company_name }}</span>
      </div>
    }
    @if (event.customer_name) {
      <div class="detail-row">
        <mat-icon>person</mat-icon>
        <span>{{ event.customer_name }}</span>
      </div>
    }

    <!-- Felhasználó (megosztott naptárból) -->
    @if (event.user_name) {
      <div class="detail-row">
        <mat-icon>account_circle</mat-icon>
        <span>{{ event.user_name }}</span>
      </div>
    }

    <!-- Létrehozó (ha más hozta létre) -->
    @if (event.created_by_name && event.created_by_name !== event.user_name) {
      <div class="detail-row">
        <mat-icon>person_add</mat-icon>
        <span>Létrehozta: {{ event.created_by_name }}</span>
      </div>
    }

    <!-- Leírás -->
    @if (event.description) {
      <div class="detail-description">
        <mat-icon>notes</mat-icon>
        @if (parsedDescription.hasStructure) {
          <div class="description-structured">
            <!-- Cég info sorok (adószám, cím, főtevékenység stb.) -->
            @for (info of parsedDescription.infoLines; track $index) {
              <div class="info-row">
                <mat-icon class="info-icon">{{ info.icon }}</mat-icon>
                <span class="info-label">{{ info.label }}:</span>
                <span class="info-value">{{ info.value }}</span>
              </div>
            }

            <!-- Cég közvetlen telefonjai (zöld chip-ek) -->
            @if (parsedDescription.companyPhones.length > 0) {
              <div class="contact-row">
                <mat-icon class="info-icon">phone</mat-icon>
                <span class="info-label">Cég tel.:</span>
                <div class="chips-container">
                  @for (phone of parsedDescription.companyPhones; track $index) {
                    <app-call-center-chip [config]="createContactChipConfig(phone, 'phone')"></app-call-center-chip>
                  }
                </div>
              </div>
            }

            <!-- Cég közvetlen emailjei (zöld chip-ek) -->
            @if (parsedDescription.companyEmails.length > 0) {
              <div class="contact-row">
                <mat-icon class="info-icon">email</mat-icon>
                <span class="info-label">Cég email:</span>
                <div class="chips-container">
                  @for (email of parsedDescription.companyEmails; track $index) {
                    <app-call-center-chip [config]="createContactChipConfig(email, 'email')"></app-call-center-chip>
                  }
                </div>
              </div>
            }

            <!-- Megjegyzés -->
            @if (parsedDescription.notes) {
              <div class="info-row notes-row">
                <mat-icon class="info-icon">sticky_note_2</mat-icon>
                <span class="info-label">Megjegyzés:</span>
                <span class="info-value">{{ parsedDescription.notes }}</span>
              </div>
            }

            <!-- Tisztségviselők (név + telefonok + emailek zöld chip-ekben) -->
            @if (parsedDescription.officials.length > 0) {
              <div class="officials-section">
                <div class="officials-header">
                  <mat-icon class="info-icon">person</mat-icon>
                  <span class="info-label">Tisztségviselők</span>
                </div>
                @for (official of parsedDescription.officials; track $index) {
                  <div class="official-entry">
                    <div class="chips-container">
                      <app-call-center-chip [config]="createContactChipConfig(official.name, 'official')"></app-call-center-chip>
                    </div>
                    @if (official.phones.length > 0) {
                      <div class="chips-container official-contacts">
                        <mat-icon class="info-icon-sm">phone</mat-icon>
                        @for (phone of official.phones; track $index) {
                          <app-call-center-chip [config]="createContactChipConfig(phone, 'phone')"></app-call-center-chip>
                        }
                      </div>
                    }
                    @if (official.emails.length > 0) {
                      <div class="chips-container official-contacts">
                        <mat-icon class="info-icon-sm">email</mat-icon>
                        @for (email of official.emails; track $index) {
                          <app-call-center-chip [config]="createContactChipConfig(email, 'email')"></app-call-center-chip>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          <p>{{ event.description }}</p>
        }
      </div>
    }
  </div>

  <div mat-dialog-actions>
    @if (isOwnReminder) {
      <app-delete-icon-button
        tooltip="Emlékeztető törlése"
        (clicked)="onDelete()">
      </app-delete-icon-button>
    }
    @if (isCalendarEvent && event.editable) {
      <app-delete-icon-button
        tooltip="Esemény törlése"
        (clicked)="onDelete()">
      </app-delete-icon-button>
      <!-- <span style="width: 8px"></span> -->
      <app-edit-icon-button
        tooltip="Esemény szerkesztése"
        (clicked)="onEdit()">
      </app-edit-icon-button>
    }

    <span class="actions-spacer"></span>

    <!-- Emlékeztető: státusz módosítás (csak saját) -->
    @if (isOwnReminder) {
      @if (event.status !== 'completed') {
        <button mat-stroked-button (click)="onStatusChange('completed')">
          <mat-icon>check_circle</mat-icon>
          Teljesítve
        </button>
      }
      @if (event.company_id) {
        <button mat-stroked-button (click)="onOpenCompanyStatus()">
          <mat-icon>edit_note</mat-icon>
          Státusz módosítása
        </button>
      }
    }

    <button mat-button (click)="onClose()">Bezárás</button>
  </div>
</div>
